const USER_DETAILS = "/me";
const USER_IMAGE = "/me/photos/48x48/$value";

export { USER_DETAILS, USER_IMAGE };